import concealedRed from "../../../images/badges/concealedCarryPolicy/concealed_red.png";

const ConcealedNegative = ({ imageProps }: any) => {
  return (
    <img src={concealedRed} alt="concealed-carry-negative" {...imageProps} />
  );
};

export default ConcealedNegative;
